import {
  Link,
  Typography,
} from '@mui/material';
import { MsgEmailProps } from '../../../../config/interfaces';

const MsgForget = (_props: MsgEmailProps) => {
  const { email } = _props;
  return (
    <>
      <Typography
        component="p"
        variant="body1"
        sx={{
          mb: 2,
          textAlign: 'justify'
        }}
      >
        We've just sent you an email with instructions on how to reset your password.
        Please check your inbox and if you don't see the email in the next few minutes,
        make sure to check your spam folder.
      </Typography>
      <Typography
        component="p"
        variant="body1"
        sx={{
          mb: 2,
          textAlign: 'justify'
        }}
      >
        If you need any further assistance with your account, feel free to reach out
        to us anytime at hello@cinemahive.com. We're always happy to help."
      </Typography>
    </>
  );
};

export default MsgForget;
